module.exports = __webpack_public_path__ + "media/img/specialize/item6-77b5517560e5cfcab97ffb6efa7a94a9.svg";